/**
 * O que a tela trava num WAF do código (spec 2026-10-14 D7). Os textos são os
 * de `TRAVADOS` em `src/consoleai/waf_codigo/gestos.py`, copiados literalmente:
 * a recusa da rota e o tooltip do botão dizem a mesma coisa.
 */
const TRAVADOS: Record<string, string> = {
  rule_create: 'Este WAF é do código: o módulo tem só as regras do conjunto dele. Regra '
    + 'nova pede evolução do módulo.',
  rule_remove: 'Regra do módulo não se apaga pela tela.',
  rule_reorder: 'A ordem das regras é fixa no módulo waf.',
  regra_fora_do_modulo: 'Esta regra não é do módulo waf; o próximo apply do stage a remove.',
  regra_fixa_do_modulo: 'A ação desta regra é fixa no módulo waf.',
  ipset_nao_allowlist: 'Este IPSet não é do módulo.',
  logging: 'O log é declarado no módulo (log_bucket_name).',
  waf_delete: 'O WAF é do código do stage {stage}.',
}

/** Texto do tooltip do gesto travado, ou `null` quando o WAF não é do código. */
export function travado(gesto: keyof typeof TRAVADOS | string, stage: string | null): string | null {
  if (!stage) return null
  const texto = TRAVADOS[gesto]
  return texto ? texto.replace('{stage}', stage) : null
}

/** A resposta 202 de um gesto desviado: o que mostrar no lugar de "aplicado". */
export function mensagemDePedido(data: { pedido_id?: number; stage?: string } | undefined): string | null {
  if (!data?.pedido_id) return null
  return `Virou o pedido #${data.pedido_id} do stage ${data.stage ?? ''}: acompanhe no painel do código.`
}
